module.exports = __webpack_public_path__ + "img/pos.3d256b6a.png";